/**
 * Native shell self-update (Tauri only). On desktop launch, checks the updater endpoint
 * (configured in tauri.conf.json → plugins.updater), and if a signed newer shell is published,
 * downloads + installs it and relaunches — no reinstall. No-op in the browser build at syqel.art.
 *
 * This is the LAYER-2 (native shell) half of the update model. The JS modules (Director / audio /
 * worlds) update separately via the OTA sync layer (./sync.ts). See docs/SIGNING_AND_RELEASE.md.
 */
export async function checkForShellUpdate(): Promise<void> {
  if (typeof window === 'undefined' || !('__TAURI_INTERNALS__' in window)) return // browser → skip
  const { resolveFlavor } = await import('../catalogue')
  const flavor = await resolveFlavor()
  if (flavor === 'appstore' || flavor === 'msstore') return // store builds ship updates via the store; no updater plugin here
  try {
    const { check } = await import('@tauri-apps/plugin-updater')
    const update = await check()
    if (!update) return
    await update.downloadAndInstall()
    const { relaunch } = await import('@tauri-apps/plugin-process')
    await relaunch()
  } catch (err) {
    console.warn('[shell-update] check failed', err)
  }
}
